/**
 * 确保节点数组中只有一个 "start" 类型的节点。
 * 如果没有，则在数组开头添加一个。
 * 如果有多个，则只保留第一个。
 */
export const ensureSingleStartNode = (nodes) => {
  const startNodes = nodes.filter((node) => node.type === 'start');

  if (startNodes.length === 0) {
    const newStartNode = {
      id: "start_node",
      type: "start",
      data: {},
      position: {
        x: 122,
        y: 333,
      }
    };
    return [newStartNode, ...nodes];
  }

  if (startNodes.length > 1) {
    const firstStartNode = startNodes[0];
    const filteredNodes = nodes.filter(
      (node) => node.type !== 'start' || node.id === firstStartNode.id
    );
    return filteredNodes;
  }

  return [...nodes];
};
